import axios from "axios";
import Constants from "../../../components.constants.js";

export default {

  async getAllBinsFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.binsUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllBinsFromServer][Store][Error occured while getting binslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getBinsFoldersFromServer(context, payload={}){
    try {
      let resp = await axios.get(Constants.binFoldersUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getBinsFoldersFromServer][Store][Error occured while getting binslist--->${error}]`
      );
      if (error.response) {
          error.response.data.statusCode = error.response.status
          return error.response.data
      }
      return {}
    }
  },
  
  async addNewBin(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.binsUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addNewBin][Store][Bin add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addNewBin][Store][Error occured while adding bin--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async getBinStatus(state, payload = {}){
    try{
      let resp = await axios.post(`${Constants.binStatusUrl}`, payload);
      if (resp.status == 200) {
        console.log(`[getBinStatus][Store][Bin status resp-->${resp.status}]`); 
        return resp.data;
      } else if (resp.status == 401) {
        //check_authorized conditions
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getBinStatus][Store][Error occured while getting bin status--->${error}]`
      );
      return {}
    }
  },

  async reVerifyBinStatus(context, payload = {}){
    try{
      let resp = await axios.get(`${Constants.binAccessibilityStatusUrl}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getBinStatus][Store][Error occured while re verifying binAccessibilityStatusUrl  --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async updateExistingBin(context, payload = {}) {
    //payload : {params:{userId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.put(`${Constants.binsUrl}/${payload.bin_id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateExistingBin][Store][Bin update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateExistingBin][Store][Error occured while updating bin--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async deleteExistingBin(context, payload = {}) {
    //payload : {params:{userId: "23412123"}, data:DAM Users JSON schema}
    try {
      let resp = await axios.delete(`${Constants.binsUrl}/${payload._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteExistingUser][Store][Bin Delete resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteExistingBin][Store][Error occured while deleting user--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },
  async getBinInfoFromServer(context, payload = {}) {
    //payload : {params:{binId:"3422344231"}}
 
    try {
      let binId = payload.params.binId
      delete payload.params.binId
      let resp = await axios.get(`${Constants.binsUrl}/${binId}`, payload);

      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getBinInfoFromServer][Store][Error occured while getting binfo --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
};
